import { gql } from '@apollo/client';

export const SEND_MESSAGE = gql`
  mutation SendMessage(
    $conversationId: ID
    $content: String!
    $tool: ToolType!
    $projectId: ID
    $reasoningEffort: ChatReasoningEffort
    $permissionMode: ChatPermissionMode
    $requestContext: ChatRequestContextInput
    $attachmentIds: [ID!]
  ) {
    sendMessage(
      conversationId: $conversationId
      content: $content
      tool: $tool
      projectId: $projectId
      reasoningEffort: $reasoningEffort
      permissionMode: $permissionMode
      requestContext: $requestContext
      attachmentIds: $attachmentIds
    ) {
      conversation {
        id
        title
        updatedAt
        isCompleted
      }
      messages {
        id
        content
        createdAt
        sender
        type
        tool
        status
        attachments {
          id
          conversationId
          messageId
          documentId
          projectId
          originalName
          mimeType
          sizeBytes
          status
          createdAt
          updatedAt
        }
        toolCalls {
          id
          messageId
          toolCallId
          toolName
          title
          input
          output
          errorText
          state
          approvalId
          approved
          approvalReason
          createdAt
          updatedAt
        }
        processSteps {
          id
          messageId
          parentId
          chatToolCallId
          type
          status
          title
          summary
          provider
          metadata
          orderIndex
          startedAt
          completedAt
          createdAt
          updatedAt
        }
      }
    }
  }
`;

export const PREPARE_CHAT_ATTACHMENT_UPLOAD = gql`
  mutation PrepareChatAttachmentUpload($input: PrepareChatAttachmentUploadInput!) {
    prepareChatAttachmentUpload(input: $input) {
      attachment {
        id
        conversationId
        messageId
        documentId
        projectId
        originalName
        mimeType
        sizeBytes
        status
        createdAt
        updatedAt
      }
      upload {
        method
        url
        headers
        expiresAt
      }
    }
  }
`;

export const CONFIRM_CHAT_ATTACHMENT_UPLOAD = gql`
  mutation ConfirmChatAttachmentUpload($input: ConfirmChatAttachmentUploadInput!) {
    confirmChatAttachmentUpload(input: $input) {
      id
      conversationId
      messageId
      documentId
      projectId
      originalName
      mimeType
      sizeBytes
      status
      createdAt
      updatedAt
    }
  }
`;

export const ADD_CHAT_ATTACHMENT_TO_DOCUMENT_HUB = gql`
  mutation AddChatAttachmentToDocumentHub($input: AddChatAttachmentToDocumentHubInput!) {
    addChatAttachmentToDocumentHub(input: $input) {
      id
      originalName
      status
      folderId
      createdAt
      updatedAt
    }
  }
`;

export const DISCARD_CHAT_ATTACHMENT_UPLOAD = gql`
  mutation DiscardChatAttachmentUpload($input: DiscardChatAttachmentUploadInput!) {
    discardChatAttachmentUpload(input: $input)
  }
`;

export const RESPOND_TO_CHAT_TOOL_APPROVAL = gql`
  mutation RespondToChatToolApproval($input: RespondToChatToolApprovalInput!) {
    respondToChatToolApproval(input: $input) {
      id
      content
      createdAt
      sender
      type
      tool
      status
      toolCalls {
        id
        messageId
        toolCallId
        toolName
        title
        input
        output
        errorText
        state
        approvalId
        approved
        approvalReason
        createdAt
        updatedAt
      }
      processSteps {
        id
        messageId
        parentId
        chatToolCallId
        type
        status
        title
        summary
        provider
        metadata
        orderIndex
        startedAt
        completedAt
        createdAt
        updatedAt
      }
    }
  }
`;

export const SEND_MESSAGE_FEEDBACK = gql`
  mutation SendMessageFeedback($messageId: ID!, $type: MessageFeedbackType!) {
    sendMessageFeedback(messageId: $messageId, type: $type) {
      id
      type
      messageId
    }
  }
`;
